const convertPxToRem = (pxValue) => `${pxValue / 16}rem`;
const stripRem = (string) => Number(string.slice(0, -3));

export { convertPxToRem, stripRem };
